import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ticket-checker-approver',
  templateUrl: './ticket-checker-approver.component.html',
  styleUrls: ['./ticket-checker-approver.component.scss']
})
export class TicketCheckerApproverComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
